// next
import NextLink from 'next/link';
// @mui
import { styled } from '@mui/material/styles';
import { Box, Link, Container, Typography, Divider, Stack } from '@mui/material';
// hooks
import useResponsive from '../../hooks/useResponsive';
// routes
import { PATH_AUTH } from '../../routes/paths';
// guards
import AuthGuard from '../../guards/AuthGuard';
// components
import Page from '../../components/Page';
import Image from '../../components/Image';
import DIOText from '../../components/DIOText';
import Iconify from '../../components/Iconify';
// sections
import { RegisterForm } from '../../sections/auth/register';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const HeaderStyle = styled('header')(({ theme }) => ({
  top: 0,
  zIndex: 9,
  lineHeight: 0,
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  position: 'absolute',
  padding: theme.spacing(2),
  justifyContent: 'space-between',
  [theme.breakpoints.up('md')]: {
    alignItems: 'flex-start',
    padding: theme.spacing(7, 5, 0, 7),
  },
}));

const SectionStyle = styled('div')(({ theme }) => ({
  width: '100%',
  maxWidth: 464,
  maxHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  backgroundColor: theme.palette.primary.main,
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0),
}));


// ----------------------------------------------------------------------

export default function Register() {
  const smUp = useResponsive('up', 'sm');
  const mdUp = useResponsive('up', 'md');

  return (
    <AuthGuard>
      <Page title="가입">
        <RootStyle>
          <HeaderStyle>
            {!smUp && (
              <Typography variant="subtitle1" sx={{ fontFamily: (theme) => theme.typography.subFontFamily }}>
                <Link underline="none" href="https://www.dio.so">DIO</Link>
              </Typography>
            )}
            <div />
            <Stack direction="row" sx={{ mt: { md: -2 } }} spacing={0.5} alignItems="center">
              <Typography variant="body2">
                사이드잡을 원하는
              </Typography>
              <Link variant="subtitle2" target="_blank" rel="noopener" href="https://crew.dio.so/auth/register/" sx={{ color: (theme) => theme.palette.info.main }}>실무자이신가요?</Link>
              <Iconify icon='ic:round-arrow-right-alt' sx={{ width: 20, height: 20 }} />
            </Stack>
          </HeaderStyle>

          {mdUp && (
            <SectionStyle>
              <Image
                visibleByDefault
                disabledEffect
                src="https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/biz-side.png"
                alt="login"
                sx={{ cursor: 'pointer' }}
                onClick={() => window.open("https://www.dio.so", '_self', 'noopener, noreferrer')}
              />
            </SectionStyle>
          )}

          <Container maxWidth="sm">
            <ContentStyle>
              <Box sx={{ pt: 10, mb: 2, display: 'flex', alignItems: 'center' }}>
                <Box sx={{ flexGrow: 1 }}>
                  <Typography variant="subtitle2">대표님, 빅테크 경력직을 파트타임으로 채용하세요.</Typography>
                  <Typography variant="h4" gutterBottom>
                    <DIOText /> 가입하고 경력직 채용하기
                  </Typography>
                </Box>
              </Box>

              <RegisterForm />

              <Typography variant="body2" align="center" sx={{ color: 'text.secondary', mt: 3 }}>
                <DIOText /> 가입하기를 선택하여 {' '}
                <Link underline="always" color="text.primary" href="https://spacey-dio.notion.site/2025-10-01-232a8b46657c817a990aed013dcbec6e" target="_blank" rel="noopener">
                  이용약관
                </Link>
                과{' '}
                <Link underline="always" color="text.primary" href="https://spacey-dio.notion.site/3d3c141952c3409c9fdc1fff82ab0a36" target="_blank" rel="noopener">
                  개인정보 보호 정책
                </Link>
                에 동의합니다.
              </Typography>

              <Divider sx={{ my: 3 }} />

              <Typography variant="body2" sx={{ textAlign: 'center' }}>
                계정이 있으신가요?{' '}
                <NextLink href={PATH_AUTH.login} passHref>
                  <Link variant="subtitle2">로그인</Link>
                </NextLink>
              </Typography>
            </ContentStyle>
          </Container>
        </RootStyle>
      </Page>
    </AuthGuard>
  );
}
